import { Box, Chip, styled } from '@mui/material';

export const StyledWeekdays = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: theme.spacing(1)
}));

/**
 * Sized by its label rather than a fixed width: every label is two letters, so the chips line up,
 * and a fixed width clipped them to "M." in the SDB theme's spacing.
 */
export const StyledWeekdayChip = styled(Chip)({
  flexShrink: 0,
  '& .MuiChip-label': {
    overflow: 'visible'
  }
});
